import React from 'react';
import styled from 'styled-components/macro';
import MuiOutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from './InputLabel';

const StyledOutlinedInput = styled(MuiOutlinedInput)`
  && {
    background-color: #fff;
    min-height: 2em;
    margin: 0.5em 0;
    min-width: ${p => (p.minwidth ? p.minwidth : '15em')};
    width: 100%;
  }
`;

export default function OutlinedInput(props) {
  return (
    <>
      {props.label ? (
        <InputLabel id={`label-${props.label}`} content={props.label} />
      ) : null}
      <StyledOutlinedInput
        // labelId={props.label ? `label-${props.label}` : null}
        {...props}
        label={undefined}
      />
    </>
  );
}
